import { useState } from 'react'
import { api, ErroApi } from '../lib/api'
import { Marca } from '../componentes/Marca'
import './conta-fluxo.css'

/**
 * "Esqueci minha senha" — pedir o link.
 *
 * ─── POR QUE ESTA TELA NÃO EXISTIA ────────────────────────────────
 *
 * `POST /v1/conta/recuperar` está na API desde o começo, testada. O
 * login apontava `href="/recuperar"` e o casco não conhecia esse
 * caminho: o clique caía na home. Na prática, **cliente que esquecia a
 * senha perdia a conta** — não havia caminho de volta em lugar nenhum
 * do produto.
 *
 * ─── A MENSAGEM É SEMPRE A MESMA, E ISSO É DE PROPÓSITO ───────────
 *
 * A API responde `{enviado:true}` exista ou não a conta. Se a tela
 * dissesse "não achamos esse e-mail", ela desfaria a defesa e viraria
 * um verificador de quem é cliente do Clinuma — numa clínica, saber que
 * um endereço é de lá já é informação sobre uma pessoa.
 */
export function Recuperar({ emailInicial = '', aoVoltar }: {
  emailInicial?: string
  aoVoltar(): void
}) {
  const [email, setEmail] = useState(emailInicial)
  const [enviando, setEnviando] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)

  async function enviar(e: React.FormEvent) {
    e.preventDefault()
    setEnviando(true); setErro(null)
    try {
      await api('/v1/conta/recuperar', { metodo: 'POST', corpo: { email: email.trim() } })
      setEnviado(true)
    } catch (err) {
      // 429 é o único erro que a pessoa consegue resolver (esperando).
      setErro(err instanceof ErroApi && err.status === 429
        ? 'Muitos pedidos deste computador. Espere alguns minutos e tente de novo.'
        : 'Não foi possível pedir o link agora. Tente de novo em instantes.')
    } finally { setEnviando(false) }
  }

  return (
    <main className="cf">
      <div className="cf__caixa cartao">
        <Marca tamanho={26} />

        {enviado ? (
          <>
            <h1>Verifique seu e-mail</h1>
            <p className="ajuda">
              Se existir uma conta com <strong>{email.trim()}</strong>, o link para
              criar uma senha nova chega em instantes. Ele vale por <strong>uma hora</strong> e
              só pode ser usado uma vez.
            </p>
            <p className="ajuda">
              Não chegou? Confira a caixa de spam. O remetente é <span className="mono">nao-responda@clinuma.com.br</span>.
            </p>
            <button className="botao botao--fantasma" onClick={aoVoltar}>Voltar para o login</button>
          </>
        ) : (
          <>
            <h1>Esqueceu a senha?</h1>
            <p className="ajuda">
              Digite o e-mail da sua conta. Mandamos um link para você criar uma nova.
            </p>

            {erro && <div className="aviso aviso--erro" role="alert">{erro}</div>}

            <form onSubmit={enviar} className="cf__form">
              <div className="campo">
                <label htmlFor="rec-email">E-mail</label>
                <input id="rec-email" className="entrada" type="email" required
                       autoComplete="email" autoFocus
                       value={email} onChange={(ev) => setEmail(ev.target.value)} />
              </div>
              <button className="botao" type="submit" disabled={enviando || !email.trim()}>
                {enviando ? 'Enviando…' : 'Enviar o link'}
              </button>
            </form>

            <button className="cf__link" onClick={aoVoltar}>Voltar para o login</button>
          </>
        )}
      </div>
    </main>
  )
}
